import React from 'react';
import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import { ChartContainer } from '../../../../../shared/components/charts/ChartContainer';

interface ICohortSizeDistributionChartProps {
	data: any;
	sizeUnit: string;
}

const CohortSizeDistributionChart: React.FC<ICohortSizeDistributionChartProps> = ({ ...props }) => {
	const options: AgChartOptions = {
		data: props.data,
		series: [
			{
				type: 'bar',
				xKey: 'size',
				yKey: 'imoCount',
				yName: '# Ships',
				xName: props.sizeUnit,
				fill: '#1f2937', // Dark blue color
			},
		],
		axes: [
			{
				type: 'category',
				position: 'bottom',
				label: {
					rotation: 0,
				},
				title: {
					text: props.sizeUnit + ' Capacity',
				},
			},
			{
				type: 'number',
				position: 'left',
				title: {
					text: '# Ships',
				},
			},
		],
		legend: {
			enabled: false,
		},
	};

	return (
		<ChartContainer
			data={options.data}
			filename="cohort_size_distribution_data"
			buttonPosition="top-right"
		>
			<AgCharts options={options} className="w-full h-full" />
		</ChartContainer>
	);
};

export default CohortSizeDistributionChart;
